<template>
  <div class="layout">
    <a-upload
      :action="url"
      :headers="headers"
      :name="fileName"
      :list-type="listType"
      :with-credentials="true"
      :multiple="true"
      :show-upload-list="{showRemoveIcon:showRemoveIcon}"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :remove="removeImg"
      v-bind="$attrs"
      class="layout-upload"
      :disabled="disabled"
      @preview="handlePreview"
      @change="handleChange"
      v-on="$listeners"
    >
      <slot v-if="!hideUploadIcon">
        <div v-if="(fileList?fileList.length:0) < Number(max)">
          <a-icon type="plus" />
          <div>{{ $t('drawingsUpload.上传') }}</div>
        </div>
      </slot>
    </a-upload>
    <img
      ref="previewImage"
      v-viewer
      :src="previewImage"
      style="display:none;"
    >
  </div>
</template>

<script>
import { getCookie } from '@/util/util.js'
import { envConfig } from '@/common/global'
export default {
  // 可以使用a-upload的其他属性和方法
  // fileList改为使用list属性，list属性有双向绑定
  props: {
    // sync 修饰符 配合 this.$emit('update:list', this.fileList)进行双向绑定
    // 父组件  :list.sync='fileList'
    list: {
      type: Array,
      default: () => []
    },
    uploadUrl: {
      type: String,
      default: 'a/api/image/batchupload'
    },
    deleteUrl: {
      type: String,
      default: 'a/api/image/delete'
    },
    // 隐藏删除图片按钮
    showRemoveIcon: {
      type: Boolean,
      default: true
    },
    isOpenDefaultRemoveLogic: { // 是否开启删除图片逻辑
      type: Boolean,
      default: false
    },
    // 允许上传图片的最大数量
    max: {
      type: [String, Number],
      default: 1
    },
    listType: {
      type: String,
      default: 'picture-card'
    },
    current: {
      type: [String, Number],
      default: 0
    },
    maxsize: {
      type: Number,
      default: 10
    },
    fileName: {
      type: String,
      default: 'pictures'
    },
    fileType: { // 文件类型 image  file
      type: String,
      default: 'image'
    },
    extraAccept: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideUploadIcon: { // 隐藏上传按钮
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fileList: [],
      previewImage: '',
      // beforeUpload中信息只提示一次
      msgOnce: '',
      url: `${this.api}${this.uploadUrl}?JSESSIONID=${getCookie(
        'JSESSIONID'
      )}&mobileLogin=true&__ajax=true`
    }
  },
  computed: {
    headers() {
      const hh = {}
      const ehsAgencyId = this.$grooveStore.get('ehsAgencyId') || localStorage.getItem('ehs.agency-id')
      if (ehsAgencyId !== undefined && ehsAgencyId !== '') {
        hh['agency-id'] = ehsAgencyId // 机构ID
      }
      const tenantId = localStorage.getItem('TENANT_ID')
      if (tenantId && tenantId !== '') {
        hh['tenant-id'] = tenantId // 租户ID
      }
      return hh
    }
  },
  watch: {
    list() {
      this.fileList = this.list
    }
  },
  created() {
    this.fileList = this.list
  },
  methods: {
    handlePreview(file) {
      if (this.fileType === 'file') {
        this.$emit('handlePreview', file)
        return
      }
      const url = file.url || file.address || file.response.data.address || `${this.api}a/api/image/downloadByimageId?imageId=${file.response.data.imageId}`
      this.previewImage = url
      // 使用定时器等待dom准备
      setTimeout(() => {
        this.$refs.previewImage.click()
      }, 500)
    },
    beforeUpload(file, fileList) {
      // const regLimit = /(.|\/)(jpe?g|png|gif|pdf)$/
      const regLimit = new RegExp('(.|\/)(jpe?g|png|gif' + this.extraAccept + ')$')
      const isPhoto = regLimit.test(file.type)
      if (!isPhoto) {
        this.$message.error('请正确上传图片')
      }
      const maxsize = this.maxsize * 1024 * 1024
      const isLt10M = file.size < maxsize
      if (!isLt10M) {
        this.$message.error(`${file.name}上传图片总大小不能大于${this.maxsize}M`)
      }
      this.msgOnce++
      const len = Number(this.max) - this.fileList.length
      const maxLimit = len >= fileList.length
      if (!maxLimit && this.msgOnce === fileList.length) {
        this.msgOnce = 0
        this.$message.error(
          `图片上传错误，该资料还需上传${len}张，请勿多传或漏传`
        )
      }
      return isPhoto && isLt10M && maxLimit
    },
    handleChange({ file, fileList }) {
      this.fileList = fileList.filter(item => {
        const { response } = item
        if (response && item.status === 'error') {
          this.$message.error(response.message || '上传失败，请重试')
        }
        if (response && item.status === 'done') {
          if (item.response.resultCode === -1) {
            this.$message.error(
              `${item.name}上传失败！请转换为RGB图片模式（截图保存）后重新提交`
            )
          } else if (item.response.resultCode === -3) {
            this.$message.error(`登录超时`)
            window.location.href = this.ssoUrl + 'auth/getVerificationToken?tokenUrl=' + window.location.href.split('/#/')[0] + `/%23/&platformName=${envConfig.platformName}`
          }
          return (
            (item.status === 'done' || item.status === 'uploading') &&
            (item.response.resultCode === 0 || item.response.resultCode === '0')
          )
        } else {
          return item.status === 'done' || item.status === 'uploading'
        }
      })
      // 等当前项图片都上传完成之后才能点击其他的upload
      this.lock = false
      let done = 0
      const count = fileList.length
      this.disabledBtn = false
      this.fileList.map(item => {
        if (item.status === 'done') {
          done++
          this.$emit('successUpload', this.fileList, this.current)
        } else {
          this.lock = true
          this.disabledBtn = true
          this.msgOnce = 0
        }
      })
      this.$emit('update:finishUpload', done === count)
      this.$emit('update:list', this.fileList)
    },
    removeImg(file) {
      // lock代表上传中
      if (this.lock) {
        if (file.response) {
          return false
        } else {
          return true
        }
      }
      if (this.isOpenDefaultRemoveLogic) { // 调用删除图片接口
        const imageId = file.response.data.imageId
        return new Promise((resolve, reject) => {
          this.$http
            .get(`${this.api}${this.deleteUrl}?imageId=${imageId}`)
            .then(res => {
              if (res.data.resultCode === 0 || res.data.resultCode === '0') {
                resolve()
              } else {
                reject()
              }
            })
        })
      }
    }
  }

}
</script>




// WEBPACK FOOTER //
// src/component/base/upload.vue